import React from 'react';
import Header from '../Components/Header/HeaderLarge';
import { resourceApi } from '../utils/fetchUtil';
import CircularProgress from 'material-ui/CircularProgress';
import Divider from 'material-ui/Divider';
import { fireInAppBrowserPlugin } from '../actions/environmentActions';

const style = {
  minHeight: 100,
  padding:25
};

const isApple  = /iPhone|iPad|iPod/i
.test(navigator.userAgent);

const isAndroid  = /Android/i
.test(navigator.userAgent);

class InactivePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      update: {
          AppStore: "",
          PlayStore: ""
      },
      isFetching: false,
      isApple: false,
      isAndroid: false
    };

    this.loadContent = this.loadContent.bind(this);
  }
    
  componentDidMount() {
   
    this.loadContent();
  }

  loadContent() {

        // We only load content for androids, who need the package name in the URL to find the app. 
      var self = this;
      this.setState({isFetching: true});

      let config = {
          method: 'get',
          url: `application/updates`
      };

      resourceApi(config) 
        .then(function (response) {

            self.setState({ update: response.data, isFetching: false });
      
      
            self.setState({isApple: isApple, isAndroid, isAndroid});
    
      
      })
      .catch(function (error) {
          console.log(error);
      });
  }


  render() {

    return (
        <div>
             <Header>
                <div className="logo-home" />
               
            </Header>

            
          <div className="container" >

                  {(this.state.isFetching) && (
                        <div style={{textAlign:'center'}}>
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <CircularProgress /> 
                            <br />
                            <br />
                        </div>
                    )}

                    {(!this.state.isFetching) && (
                        <div className="container" >
                            <div className="container trueno centered">
                                <br />
                                <br />
                                <br />
                                <br />
                                <h2>Update Is Available!</h2>
                            </div>
                            <div className="centered container"  >
                                <p>Good news! A new version of the <br /> {this.state.update.AppName} App is available.</p>
                                <br />
                                {(this.state.isApple) && (
                                    <h4><a onclick={()=>{fireInAppBrowserPlugin(this.state.update.AppStore)}} style={{textDecoration: 'none'}}>Click Here to Update</a></h4>
                                )}
                                {(this.state.isAndroid) && (
                                    <h4><a onClick={()=>{fireInAppBrowserPlugin(this.state.update.PlayStore)}} style={{textDecoration:'none'}} >Click Here to Update</a> </h4>
                                )}
                                  <br />
                            </div>
                        </div>
                    )}
            <br />
            <br />
          </div>
        </div>
    );
  }

};

export default InactivePage;


// WEBPACK FOOTER //
// ./src/Pages/Inactive.js